import { useSyncExternalStore } from 'react'

import { isAlertSoundReady, subscribeAlertSound } from '../services/alertSound'

/** صوت التنبيهات مسموحٌ بهذا المتصفح الآن — يتبدّل حيّاً مع أول نقرة للموظف */
export function useAlertSoundReady(): boolean {
  return useSyncExternalStore(subscribeAlertSound, isAlertSoundReady, isAlertSoundReady)
}
